module.exports = __webpack_public_path__ + "img/d75989a36d4f820f970dc8d9b5ffbb06.png";